'use client'

import type { FC } from 'react'
import { Label } from 'ui/label'
import FormUploadImage from '../FormUploadImage'
import FieldWrapper from './FieldWrapper'
import type { FieldRendererProps } from './types'

const ImageField: FC<FieldRendererProps> = ({ field, value, error, onChange }) => {
    const imageUrl = value
    const isValidImageUrl =
        typeof imageUrl === 'string' &&
        imageUrl !== '{}' &&
        imageUrl !== '' &&
        (imageUrl.startsWith('/') || imageUrl.startsWith('http'))

    return (
        <FieldWrapper fieldName={field.name} error={error}>
            <Label htmlFor={field.name}>{field.label}</Label>
            <FormUploadImage
                name={field.name}
                className='w-[150px] h-[150px]'
                alt={field.label as string}
                src={isValidImageUrl ? imageUrl : ''}
                onChange={file => onChange(field.name, file, field)}
            />
        </FieldWrapper>
    )
}

export default ImageField
